module.exports = __webpack_public_path__ + "media/src/images/trading_on-9a96d5ae479f38704c4e5a7bd7bd8f25.png";